import React from 'react';
import PropTypes from 'prop-types'

const IconCamera = ({ color, ...props }) => (
    <svg width="15px" height="10px" viewBox="0 0 15 10" {...props}>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          transform="translate(-8.000000, -7.000000)"
          fill={color || 'currentColor'}
        >
          <g transform="translate(8.835779, 5.000000)">
            <g>
              <path d="M11.9834167,2.47916667 C12.7879579,2.47916667 13.44,3.13120876 13.44,3.93575 L13.44,10.1774167 C13.44,10.9819579 12.7879579,11.634 11.9834167,11.634 L1.60241667,11.634 C0.797875422,11.634 0.145833333,10.9819579 0.145833333,10.1774167 L0.145833333,3.93575 C0.145833333,3.13120876 0.797875422,2.47916667 1.60241667,2.47916667 L11.9834167,2.47916667 Z M11.9834167,3.35416667 L1.60241667,3.35416667 C1.28112458,3.35416667 1.02083333,3.61445791 1.02083333,3.93575 L1.02083333,10.1774167 C1.02083333,10.4987088 1.28112458,10.759 1.60241667,10.759 L11.9834167,10.759 C12.3047088,10.759 12.565,10.4987088 12.565,10.1774167 L12.565,3.93575 C12.565,3.61445791 12.3047088,3.35416667 11.9834167,3.35416667 Z M6.410425,4.1538 C7.94063291,4.1538 9.18125833,5.39442542 9.18125833,6.92463333 C9.18125833,8.45484124 7.94063291,9.69546667 6.410425,9.69546667 C4.88021709,9.69546667 3.63959167,8.45484124 3.63959167,6.92463333 C3.63959167,5.39442542 4.88021709,4.1538 6.410425,4.1538 Z M6.410425,5.0288 C5.36346624,5.0288 4.51459167,5.87767458 4.51459167,6.92463333 C4.51459167,7.97159209 5.36346624,8.82046667 6.410425,8.82046667 C7.45738376,8.82046667 8.30625833,7.97159209 8.30625833,6.92463333 C8.30625833,5.87767458 7.45738376,5.0288 6.410425,5.0288 Z M11.3400583,4.1538 L11.3400583,5.1538 L10.2305583,5.1538 L10.2305583,4.1538 L11.3400583,4.1538 Z" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );

IconCamera.propTypes = {
  color: PropTypes.string
}

export default IconCamera;
